
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { useErrorTracking } from './hooks/monitoring/useErrorTracking';

// Get the root element
const rootElement = document.getElementById('root');

// Validate that the root element exists
if (!rootElement) {
  console.error("Root element not found in the DOM");
  throw new Error("Root element not found in the DOM");
}

// Create and render the React root
ReactDOM.createRoot(rootElement).render(
  <App />
);
